module.exports = __webpack_public_path__ + "static/media/1.09c51c4e.jpg";